import { TYPE_CHECK_BOX, TYPE_CONTENT_DATE, TYPE_CONTENT_TEXT, TYPE_CREATED_TIME, TYPE_DATE, TYPE_DATE_TIME, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT, TYPE_UPDATE_TIME } from '@/config/constants';
import { addComasNumber, formatDateTime } from '@/utils';

const returnItemWithUnit = (content, unit, unitPosition) => {
    if (unit && unitPosition == 'AFTER' && content) {
        return content + ' ' + unit;
    }
    if (unit && unitPosition == 'BEFORE' && content) {
        return unit + ' ' + content;
    }
    return content;
};

const mapListFieldView = (listFields, arrayFieldView) => {
    if (Object.keys(listFields).length === 0) return {};
    if (!arrayFieldView) return listFields;
    let listFieldView = {};
    arrayFieldView.forEach((item) => {
        if (listFields[item.code]) {
            listFieldView[item.code] = listFields[item.code];
        }
    });
    return listFieldView;
};

const mapDataRecord = (data, listFieldKeys, listField) => {
    let dataResponse = [];
    dataResponse = data.map((value) => {
        let dataMap = {
            id: value['$id'],
            data: []
        };

        listFieldKeys.forEach((field) => {
            dataMap.data.push({
                title: listField[field].label,
                content_data: onGetContentData(value, field, listField),
                field: field,
                value: value[field],
                unit: listField[field].unit,
                unitPosition: listField[field].unitPosition,
                format: listField[field].format
            });
        });
        return dataMap;
    });
    return dataResponse;
};

const onGetContentData = (record, field, listField) => {
    let result = '';
    if (record && field) {
        let typeField = record[field].type;
        let formatCalc = listField[field] && listField[field].format ? listField[field].format : null;
        if (TYPE_CONTENT_TEXT.includes(typeField) && typeField !== 'CALC') {
            if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(typeField)) {
                result = record[field].value ? record[field].value.replaceAll(';', ', ') : '';
            } else {
                result = record[field].value;
            }
        } else if (TYPE_CONTENT_DATE.includes(typeField)) {
            if ([TYPE_DATE_TIME, TYPE_CREATED_TIME, TYPE_UPDATE_TIME].includes(typeField)) {
                result = record[field].value ? formatDateTime(record[field].value, 'YYYY/MM/DD HH:mm') : '';
            } else {
                result = record[field].value ? formatDateTime(record[field].value, 'YYYY/MM/DD') : '';
            }
        } else if (typeField === 'NUMBER') {
            result = record[field].value ? addComasNumber(Number(record[field].value)) : '';
        } else if (typeField === 'CALC') {
            switch (formatCalc) {
                case TYPE_DATE_TIME:
                    result = record[field].value ? formatDateTime(record[field].value, 'YYYY/MM/DD HH:mm') : '';
                    break;
                case 'NUMBER_DIGIT':
                    result = record[field].value ? addComasNumber(Number(record[field].value)) : '';
                    break;
                case TYPE_DATE:
                    result = record[field].value ? formatDateTime(record[field].value, 'YYYY/MM/DD') : '';
                    break;
                default:
                    result = record[field].value;
            }
        } else if (typeField === 'SUBTABLE') {
            result = '[Data Table]';
        } else {
            result = record[field].value;
        }
    } else {
        result = '';
    }
    return result;
};

export { returnItemWithUnit, mapListFieldView, mapDataRecord };
